import type { CapitalReport } from './types';
import { G1_REPORTS } from './g1';
import { G2_REPORTS } from './g2';
import { G3_REPORTS } from './g3';
import { G4_REPORTS } from './g4';
import { applyReportOverride, capitalOverride } from '../reportContent';

export type { CapitalReport, ReportSection, ReportBlock, TableCell, Tone } from './types';

const ALL: CapitalReport[] = [...G1_REPORTS, ...G2_REPORTS, ...G3_REPORTS, ...G4_REPORTS];

export const REPORTS_BY_KEY: Record<string, CapitalReport> = ALL.reduce(
  (acc, r) => { acc[r.key] = r; return acc; },
  {} as Record<string, CapitalReport>,
);

// Capital-readiness score → risk band R1..R7. Thresholds mirror the dashboard's
// crColor scale and mapToR(): R1 ≤33, R2 ≤41, R3 ≤48, R4 ≤56, R5 ≤65, R6 ≤74, else R7.
export function scoreToRCode(score: number): string {
  if (score <= 33) return 'R1';
  if (score <= 41) return 'R2';
  if (score <= 48) return 'R3';
  if (score <= 56) return 'R4';
  if (score <= 65) return 'R5';
  if (score <= 74) return 'R6';
  return 'R7';
}

// Resolve the report for a goal group (G1–G4) and capital-readiness score.
// Falls back to G1 if the group is missing/invalid.
export function getCapitalReport(group: string | undefined | null, score: number): CapitalReport | undefined {
  const g = group === 'G1' || group === 'G2' || group === 'G3' || group === 'G4' ? group : 'G1';
  const r = REPORTS_BY_KEY[`${g}${scoreToRCode(score)}`];
  return r ? applyReportOverride(r, capitalOverride(r.key)) : r;
}
